export const GA_TRACKING_ID = "G-1N8X3LD16X";
